import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ContentPanel } from "../components/file-uploader/contentPanel";
import { Hero } from "../layouts/hero";
import { CategoryObj } from "../utilities/fileUploader/objects";
import { UPLOAD } from "../routes/routes";
import { MainLayout } from "../layouts/mainLayout";

function FileUploader() {
  const location = useLocation();
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (location.pathname === `/${UPLOAD}`) {
      setTitle("File Uploader");
    } else {
      if (location.state) {
        CategoryObj().some((e) =>
          e.value === location.state.value ? setTitle(e.title) : ""
        );
      } else {
        CategoryObj().some((e) =>
          location.pathname.includes(e.routes) ? setTitle(e.title) : ""
        );
      }
    }
  }, [location.state, location.pathname]);

  return (
    <MainLayout>
      <div className="main">
        <Hero
          title={title}
          desc={
            <>
              Marketing tools makes it easier for individuals & teams to achieve their collective
              goals, create professional marketing branded assets and stay
              informed with features across our projects
            </>
          }
          logoWidth={"w-8/12"}
        />

        <ContentPanel />
      </div>
    </MainLayout>
  );
}

export default FileUploader;
